import _regeneratorRuntime from "@babel/runtime/regenerator";
import { CodedError } from '@unimodules/core';
import ExpoFontLoader from "./ExpoFontLoader";
import { FontDisplay } from "./Font";

function uriFromFontSource(asset) {
  if (typeof asset === 'string') {
    return asset || null;
  } else if (typeof asset === 'object') {
    return asset.uri || asset.localUri || null;
  }

  return null;
}

function displayFromFontSource(asset) {
  return asset.display || FontDisplay.AUTO;
}

export function fontFamilyNeedsScoping(name) {
  return false;
}
export function getAssetForSource(source) {
  var uri = uriFromFontSource(source);
  var display = displayFromFontSource(source);

  if (!uri || typeof uri !== 'string') {
    throwInvalidSourceError(uri);
  }

  return {
    uri: uri,
    display: display
  };
}

function throwInvalidSourceError(source) {
  var type = typeof source;
  if (type === 'object') type = JSON.stringify(source, null, 2);
  throw new CodedError("ERR_FONT_SOURCE", "Expected font asset of type `string | FontResource | Asset` (number is not supported on web) instead got: " + type);
}

export function loadSingleFontAsync(name, input) {
  return _regeneratorRuntime.async(function loadSingleFontAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (typeof input !== 'object' || typeof input.uri !== 'string' || input.downloadAsync) {
            throwInvalidSourceError(input);
          }

          _context.next = 3;
          return _regeneratorRuntime.awrap(ExpoFontLoader.loadAsync(name, input));

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, null, Promise);
}
export function getNativeFontName(name) {
  return name;
}